import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x">
      <div className="container-fluid content">
        {/* <a className="navbar-brand" href="/">
          <img src="/home1/assets/img/logo.png" alt="" className="logo" />
          
        </a> */}
        <div className="nav-social2">
          <a href="https://wa.me/9895096500" target="_blank">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="https://www.instagram.com/af.thab._?utm_source=qr&igsh=cm1vazZtNzE1NDhk" target="_blank">
                <i className="fab fa-instagram"></i>
              </a>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 allnav">
            <li className="nav-item">
              <a className="nav-link" aria-current="page" href="/">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#aboutme">
                About
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#myart">
                My Works
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact
              </a>
            </li>
          </ul>
          <div className="nav-side ">
            <div className="nav-social">
              <a href="https://wa.me/9895096500" target="_blank">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="https://www.instagram.com/af.thab._?utm_source=qr&igsh=cm1vazZtNzE1NDhk" target="_blank">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
